import React from "react";

export default function SubscriptionImageIco() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 367 196"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <g clip-path="url(#clip0_5045_13448)">
          <circle cx="198" cy="98" r="192" fill="#EBE1F9" />
          <circle cx="198" cy="98" r="149" fill="#D7C4F3" />
          <circle cx="198" cy="98" r="110" fill="#C2A8ED" />
          <path
            d="M139.268 141.07C214.837 198.553 261.884 137.964 263.337 109.959L235.725 108.485C228.75 143.859 177.052 146.965 156.707 121.909L139.268 141.07Z"
            fill="url(#paint0_linear_5045_13448)"
          />
          <ellipse
            cx="205.215"
            cy="90.797"
            rx="30.5181"
            ry="30.9523"
            fill="#9670DF"
          />
          <path
            d="M213.925 33.3157C237.222 37.6119 233.35 56.0933 227.35 67.1509C226.244 69.189 224.576 70.8635 222.581 72.046C211.614 78.5487 201.475 79.688 195.959 79.3098C194.363 79.2004 192.737 78.9796 191.137 78.9812C140.078 79.0296 139.422 117.142 145.622 136.49C117.144 114.827 132.414 62.7025 162.221 42.9075C177.769 32.5823 196.495 30.1015 213.925 33.3157Z"
            fill="#7F56D9"
          />
          <path
            d="M177.6 107.01C228.754 117.622 247.356 79.9883 250.262 59.8447C274.677 86.9648 263.341 120.275 254.622 133.541C247.356 123.223 234.277 112.906 218.291 121.749C206.664 128.181 194.157 135.913 187.976 139.849C186.88 140.547 185.661 141.032 184.37 141.165C174.711 142.16 158.34 140.109 157.255 124.697C156.092 108.189 170.334 106.028 177.6 107.01Z"
            fill="#7F56D9"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5045_13448"
          x1="139.268"
          y1="125.359"
          x2="260.5"
          y2="145.462"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.104" stop-color="#C2A8ED" />
          <stop offset="0.476722" stop-color="#9670DF" />
          <stop offset="1" stop-color="#9670DF" />
        </linearGradient>
        <clipPath id="clip0_5045_13448">
          <rect width="367" height="196" rx="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
